import { mapGetters, mapActions } from 'vuex';
import contentHeader from '@/components/generics/content-header/content-header.vue';

export default {
  props: {
    title: {
      type: String,
      default: 'Community Forums',
    },
  },
  components: {
    contentHeader,
  },
  data() {
    return {
      url: '',
    };
  },
  metaInfo() {
    return {
      title: 'Learn',
    };
  },
  created() {
    this.loadForum();
  },
  watch: {
    isLoggedIn() {
      this.loadForum();
    },
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('app', ['isLayoutMobile']),
  },
  methods: {
    ...mapActions('support', ['getForumUrl']),
    loadForum() {
      this.getForumUrl()
        .then((data) => {
          this.url = data;
        });
    },
    onClose() {
      this.$router.push({
        name: 'HelpAndSupport',
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/support/community-forums/community-forums.js